/* ============================================
   URBAN FURNISHING – Custom Header & Search Suggestions
   ============================================ */

function initUFHeaderSearch() {
  const searchForms = document.querySelectorAll('.ch-search');
  if (!searchForms.length) return;

  const popularSearches = ["Sofas", "Wardrobes", "Beds", "Dressing Table", "Corner Sofa", "Shoe Cabinets"];

  searchForms.forEach(form => {
    const input = form.querySelector('input[name="q"]');
    if (!input) return;

    // Create suggestions panel if not exists
    let suggestions = form.querySelector('.ch-search-suggestions');
    if (!suggestions) {
      suggestions = document.createElement('div');
      suggestions.className = 'ch-search-suggestions';
      form.appendChild(suggestions);
    }

    let debounceTimer = null;

    // Render Popular Suggestions State
    function renderPopular() {
      let html = `
        <div class="ch-search-suggestions__title">Popular Searches</div>
        <div class="ch-search-suggestions__tags">
          ${popularSearches.map(term => `<button type="button" class="ch-search-tag" data-query="${term}">${term}</button>`).join('')}
        </div>
      `;
      suggestions.innerHTML = html;
      bindTagEvents();
    }

    // Bind Click on Popular Tags
    function bindTagEvents() {
      const tags = suggestions.querySelectorAll('.ch-search-tag');
      tags.forEach(tag => {
        tag.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          const q = tag.dataset.query;
          input.value = q;
          fetchSuggestions(q);
        });
      });
    }

    // Fetch Predictive Results from Shopify API
    async function fetchSuggestions(query) {
      const q = query.trim();
      if (!q) {
        renderPopular();
        suggestions.classList.add('is-visible');
        return;
      }

      try {
        const response = await fetch(`/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=5`);
        if (!response.ok) throw new Error('Search API error');
        const data = await response.json();
        
        const products = data.resources?.results?.products || [];
        renderResults(q, products);
      } catch (err) {
        console.warn('Predictive search fallback:', err);
        renderResults(q, []);
      }
    }

    // Render Search Results State
    function renderResults(q, products) {
      if (!products || products.length === 0) {
        suggestions.innerHTML = `
          <div class="ch-search-suggestions__title">No direct products found for "${escapeHtml(q)}"</div>
          <button type="submit" class="ch-search-suggestions__view-all">Search for "${escapeHtml(q)}" &rarr;</button>
        `;
      } else {
        let html = `
          <div class="ch-search-suggestions__title">Product Suggestions</div>
          <div class="ch-search-suggestions__products">
        `;
        products.forEach(p => {
          const imgUrl = p.image || p.featured_image?.url || p.featured_image || '';
          const priceFormatted = p.price ? (p.price.toString().includes('£') || p.price.toString().includes('$') ? p.price : `£${(parseFloat(p.price) / 100).toFixed(2)}`) : '';
          const comparePriceFormatted = p.compare_at_price ? (p.compare_at_price.toString().includes('£') || p.compare_at_price.toString().includes('$') ? p.compare_at_price : `£${(parseFloat(p.compare_at_price) / 100).toFixed(2)}`) : '';

          html += `
            <a href="${p.url}" class="ch-search-product-item">
              ${imgUrl ? `<img src="${imgUrl}" alt="${escapeHtml(p.title)}" class="ch-search-product-item__img">` : ''}
              <div class="ch-search-product-item__info">
                <div class="ch-search-product-item__title">${escapeHtml(p.title)}</div>
                ${priceFormatted ? `<div class="ch-search-product-item__price">${priceFormatted} ${comparePriceFormatted ? `<s>${comparePriceFormatted}</s>` : ''}</div>` : ''}
              </div>
            </a>
          `;
        });
        html += `
          </div>
          <button type="submit" class="ch-search-suggestions__view-all">View all results for "${escapeHtml(q)}" &rarr;</button>
        `;
        suggestions.innerHTML = html;
      }
      suggestions.classList.add('is-visible');
    }

    function escapeHtml(str) {
      return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    }

    // Input Focus Event
    input.addEventListener('focus', () => {
      if (input.value.trim() === '') {
        renderPopular();
      } else {
        fetchSuggestions(input.value);
      }
      suggestions.classList.add('is-visible');
    });

    // Input Typing Event (Debounced)
    input.addEventListener('input', () => {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
        if (input.value.trim() === '') {
          renderPopular();
        } else {
          fetchSuggestions(input.value);
        }
      }, 250);
    });

    // Handle form submit button inside suggestions
    suggestions.addEventListener('click', (e) => {
      if (e.target.classList.contains('ch-search-suggestions__view-all')) {
        form.submit();
      }
    });
  });

  // Hide dropdown when clicking outside
  document.addEventListener('click', (e) => {
    if (!e.target.closest('.ch-search')) {
      document.querySelectorAll('.ch-search-suggestions').forEach(el => el.classList.remove('is-visible'));
    }
  });

  // Hide dropdown on Escape key
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      document.querySelectorAll('.ch-search-suggestions').forEach(el => el.classList.remove('is-visible'));
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initUFHeaderSearch, { once: true });
} else {
  initUFHeaderSearch();
}
